import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=4c9e6526&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=4c9e6526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9e6526",
  null
  
)

export default component.exports